export default __webpack_public_path__ + "static/media/settings.790fa951.svg";